import { ResourcesTabs } from 'services/tabs';

type Translate = (key: string) => string;

const RESOURCES_TAB_TITLE_KEY_BY_TAB: Record<ResourcesTabs, string> = {
    [ResourcesTabs.Docs]: 'Docs & Tools',
};

export const isResourcesTab = (value: unknown): value is ResourcesTabs => {
    return typeof value === 'string' && value === ResourcesTabs.Docs;
};

export const getResourcesTitle = (tab: unknown, t: Translate): string => {
    if (isResourcesTab(tab)) {
        return t(RESOURCES_TAB_TITLE_KEY_BY_TAB[tab]);
    }
    return t('Resources');
};
